import React from 'react';
import NumberDisplay from "../NumberDisplay";
import {TaggedLogger} from "@nextlot/core/utilities";


type RootCmpPropsType = {
    label:string,
    valueCents: number,
    textForEmptyValue?: string,
    validateAndSubmitNewValueCents: (valueCents:number)=>string|null,  // string=validation-error

    componentClassName?: string,
    numberDisplayClassName?: string,
}



const _logger = TaggedLogger.get('ClerkBiddingEditableNumericDisplayRowCmp');



export default function ClerkBiddingEditableNumericDisplayRowCmp(props:RootCmpPropsType) {
    const refInput = React.useRef<HTMLInputElement>();
    const [isEditMode, setIsEditMode] = React.useState(false);
    const [validationError, setValidationError] = React.useState<string|null>(null);
    const [inputRawValue, setInputRawValue] = React.useState<string>('');

    React.useEffect(() => {
        if (isEditMode) {
            refInput.current?.focus();
        }
        else {
            setInputRawValue('');
            setValidationError(null);
        }
    }, [isEditMode]);


    const handleOnClick_AskValue = () => {
        if (!isEditMode) {
            setIsEditMode(true);
        }
    }

    const handleOnClick_ToggleEditIcon = () => {
        setIsEditMode(prevState => (!prevState));
    }

    const handleOnSubmit_Form = (evt) => {
        evt.preventDefault();

        const valueFloat:number = parseFloat(inputRawValue);
        if (! valueFloat) {
            setValidationError('Must be a number');
            return
        }
        const valueCents = valueFloat * 100;
        if (valueCents <= 0) {
            setValidationError('Must be greater than 0');
            return
        }

        const errorMessage = props.validateAndSubmitNewValueCents(valueCents);

        if (errorMessage) {
            setValidationError(errorMessage);
        }
        else {
            setValidationError(null);
        }
    }


    const handleOnChange_Input = (evt) => {
        setInputRawValue(evt.target.value);
    }

    const handleOnKeyUp_Input = (evt) => {
        if (evt.keyCode === 27) {
            // reset
            setValidationError(null);
        }
    }

    const handleOnBlur_Input = (evt) => {
        if (inputRawValue === '') {
            // reset
            setValidationError(null);
        }
    }


    const inputValidClassName:string = validationError ? 'is-invalid' : '';

    return (
        <div className={props.componentClassName || 'bidding-values__row--editable-numeric'}>
            <div className="row__label">{props.label}</div>
            <div className="row__content">
                <NumberDisplay
                    valueCents={props.valueCents}
                    textIfEmpty={props.textForEmptyValue}
                    allowZero={false}
                    onClick={handleOnClick_AskValue}
                />

                <span className="separator toggle-edit-button" onClick={handleOnClick_ToggleEditIcon}>
                    {
                        isEditMode
                            ? <i className="fa-regular fa-times-circle icon-cancel" />
                            : <i className="fa-regular fa-edit icon-edit" />
                    }
                </span>


                {
                    isEditMode
                    &&
                    <form className="form-edit-container" onSubmit={handleOnSubmit_Form}>
                        <input className={`form-control ${inputValidClassName}`}
                               type="number" step="0.01"
                               value={inputRawValue}
                               onChange={handleOnChange_Input}
                               onKeyUp={handleOnKeyUp_Input}
                               onBlur={handleOnBlur_Input}
                               ref={refInput}
                        />
                        <input type="submit" className="invisible" value="" />
                    </form>
                }
            </div>
        </div>
    )
}



//
// type RootCmpStateType = Partial<{
//     isEditMode: boolean,
//     inputValue: number|'',
//     isValidating: boolean,
//     validationError: string|false|null, // null=not-validated; string=invalid; false=valid
//     submittedValueCents: number|false,
// }>
//
// const initialResetState:RootCmpStateType = {
//     isEditMode: false,
//     inputValue: '',
//     validationError: null,
//     isValidating: false,
//     submittedValueCents: false,
// };
//
//
// class OLD_COMPONENT extends React.Component<RootCmpPropsType, RootCmpStateType>{
//     protected readonly refInput: React.RefObject<HTMLInputElement>;
//
//
//     constructor(props) {
//         super(props);
//         this.refInput = React.createRef();
//         this.state = {
//             ...initialResetState
//         };
//     }
//
//     componentDidUpdate(prevProps: RootCmpPropsType): void {
//         // _logger.debug('.componentDidUpdate: ', { prevProps, this_props: this.props, this_state: this.state });
//
//         if (prevProps.valueCents !== this.props.valueCents) {
//             // we have a new value coming from the server, then ...
//
//             // if we successfully submitted a value, and ...
//             if (this.state.isEditMode && this.state.submittedValueCents) {
//                 // the value we submitted is the same as the received value
//                 if (this.state.submittedValueCents === this.props.valueCents) {
//                     // reset the component state
//                     this.setState({
//                         ...initialResetState
//                     });
//                 }
//                 else {
//                     // it's not the value we submitted
//                     // => our value is invalid, and the server actually didn't accept our value
//                     this.setState({
//                         submittedValueCents: null,
//                         validationError: 'Invalid value (server rejected)',
//                         isValidating: false,
//                     })
//                 }
//             }
//         }
//     }
//
//
//     handleOnClick_AskValue = () => {
//         if ( ! this.state.isEditMode) {
//             this.setState({
//                 isEditMode: true,
//             }, () => {
//                 this.state.isEditMode && this.refInput.current && this.refInput.current.focus();
//             })
//         }
//     };
//
//
//     handleOnClick_ToggleEditIcon = (evt) => {
//         evt.preventDefault();
//
//         this.setState({
//             isEditMode: ! this.state.isEditMode
//         }, () => {
//             this.state.isEditMode && this.refInput.current && this.refInput.current.focus();
//         });
//     };
//
//
//     handleOnSubmit_Form = (evt) => {
//         evt.stopPropagation();
//         evt.preventDefault();
//
//         if (! this.state.isEditMode) {
//             // do nothing if we're not in edit mode -- should never get here
//             return;
//         }
//
//         this.setState({
//             isValidating: true,
//         }, () => {
//
//             const validateAndSubmitResult = this.props.validateAndSubmitNewValueCents(this.state.inputValue);
//
//             let newState:RootCmpStateType;
//             // if result is an integer => success
//             if (Number.isInteger(validateAndSubmitResult)) {
//                 newState = {
//                     validationError: false,
//                     submittedValueCents: validateAndSubmitResult as number,
//                 };
//             }
//             else {
//                 newState = {
//                     validationError: validateAndSubmitResult as string,
//                     submittedValueCents: false,
//                 };
//             }
//
//             this.setState({
//                 ...newState,
//                 isValidating: false,
//             });
//
//         });
//     };
//
//
//     handleOnChange_Input = (evt) => {
//         this.setState({
//             inputValue: evt.target.value,
//         })
//     };
//
//     handleOnKeyUp_Input = (evt) => {
//         if (evt.keyCode === 27) {
//             this.setState({
//                 ...initialResetState
//             });
//         }
//     };
//
//     handleOnBlur_Input = () => {
//         if (this.state.inputValue === '') {
//             this.setState({
//                 ...initialResetState
//             })
//
//         }
//     };
//
//
//
//     render() {
//         // _logger.debug('.render: this.state', this.state, 'this.props');
//
//         let inputValidClassName:string = this.state.validationError ? 'is-invalid' : '';
//
//         return (
//             <div className={this.props.componentClassName || 'bidding-values__row--editable-numeric'}>
//                 <div className="row__label">{this.props.label}</div>
//                 <div className="row__content">
//                     <NumberDisplay
//                         valueCents={this.props.valueCents}
//                         textIfEmpty={this.props.textForEmptyValue}
//                         allowZero={false}
//                         onClick={this.handleOnClick_AskValue}
//                     />
//
//                     <a className="separator toggle-edit-button" onClick={this.handleOnClick_ToggleEditIcon} href="#">{
//                         this.state.isEditMode
//                             ? <i className="fa-regular fa-times-circle icon-cancel" />
//                             : <i className="fa-regular fa-edit icon-edit" />
//                     }</a>
//
//
//                     {
//                         this.state.isEditMode &&
//                         <form className="form-edit-container" onSubmit={this.handleOnSubmit_Form}>
//                             <input className={`form-control ${inputValidClassName}`}
//                                    type="number" step="0.01"
//                                    value={this.state.inputValue}
//                                    onChange={this.handleOnChange_Input}
//                                    onKeyUp={this.handleOnKeyUp_Input}
//                                    onBlur={this.handleOnBlur_Input}
//                                    ref={this.refInput}
//                             />
//                             <input type="submit" className="invisible" value="" />
//                         </form>
//                     }
//                 </div>
//             </div>
//         )
//     }
// }
